import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'ld-collapse-button',
  templateUrl: 'collapse-button.template.html',
  styleUrls: ['collapse-button.styles.css']
})
export class CollapseButtonComponent {
  private click: EventEmitter<any> = new EventEmitter();

  onClick(): void {
    this.click.emit();
  }
}
